<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <template v-slot:activator="{ on }">
        <v-btn color="#c4c22c" fab x-small dark v-on="on"><v-icon>create</v-icon></v-btn>
      </template>
      <v-card>
        <v-toolbar dark color="#c4c22c">
          <v-btn icon dark @click="confirmClose">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title></v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon large dark text @click="updateLeadData">
              <v-icon>mdi-content-save-edit-outline</v-icon>

            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <div class="reports">
        <h1>{{lead.current_step}} - Processo {{lead.lead_process_id}}<span class="h1-underline"></span></h1>
          <div class="container">
             <v-container>
                <v-row>
                  <v-col
                    :cols="9"
                  >
                   <v-card class="colunas">
                      <h2>Cliente - {{lead.nome}}<span class="h2-underline"></span></h2>

                      <Calls 
                        class="call-button"
                        :resultados="radioElem"
                        :dataAgendamento="lead.callback_date == null ? '' : new Date(lead.callback_date)"
                        :lead_process_id="lead.lead_process_id"
                        :formatDate="formatDate"
                        @update-history="reloadData"
                        @update-history-final="reloadDataFinal"
                      />

                      <template>
                        <v-card flat class="tabs-container">
                          <v-tabs
                            v-model="tab"
                            color= "#c4c22c"
                          >
                            <v-tab
                              v-for="item in items"
                              :key="item.tab"
                            >
                              {{ item.tab }}
                            </v-tab>
                          </v-tabs>

                            <v-tabs-items v-model="tab">
                              <v-tab-item
                                v-for="item in items"
                                :key="item.tab"
                              >
                              <v-row
                                v-if="item.desc === 'obs'"
                              >

                                <v-col  
                                  :cols="12"
                                  v-for="input in item.content" 
                                  :key="input.name"
                                  class="col-padding"
                                >
                                  <v-card flat>
                                    <v-card-text class="inputs-container">
                                      <v-row>
                                        <v-col
                                          :cols="4"
                                        >
                                          <h2 class="h2-resumo">Nome</h2>
                                          <h3 class="h3-resumo">{{lead.nome}}</h3>
                                        </v-col>
                                        <v-col
                                          :cols="4"
                                        >
                                          <h2 class="h2-resumo">Email</h2>
                                          <h3 class="h3-resumo">{{lead.email}}</h3>
                                        </v-col>
                                        <v-col
                                          :cols="4"
                                        >
                                          <h2 class="h2-resumo">Telefone</h2>
                                          <h3 class="h3-resumo">{{lead.telefone}}</h3>
                                        </v-col>
                                      </v-row>
                                      <v-row>
                                        <v-col
                                          :cols="4"
                                        >
                                          <h2 class="h2-resumo">Produto</h2>
                                          <h3 class="h3-resumo">{{lead.produto}}</h3>
                                        </v-col>
                                        <v-col
                                          :cols="4"
                                        >
                                          <h2 class="h2-resumo">Montante</h2>
                                          <h3 class="h3-resumo">{{lead.aux_1}}</h3>
                                        </v-col>
                                        <v-col
                                          :cols="4"
                                        >
                                          <h2 class="h2-resumo">Prazo</h2>
                                          <h3 class="h3-resumo">{{lead.aux_2*12}} meses</h3>
                                        </v-col>
                                      </v-row>
                                      <v-spacer></v-spacer>
                                      <v-row>
                                        <v-textarea
                                          outlined
                                          :label="input.title"
                                          :value="input.value"
                                          v-model="input.value"
                                        ></v-textarea>
                                      </v-row>
                                    </v-card-text>
                                  </v-card>
                                </v-col>
                              </v-row>
                              <v-row
                                v-else 
                              >
                                <v-col
                                  v-for="input in item.content" 
                                  :cols="input.cols"
                                  :key="input.title"
                                  class="col-padding"
                                >
                                  <v-card flat>
                                    <v-card-text class="inputs-container">
                                      <v-text-field
                                          outlined
                                          v-if="input.type === 'text'"
                                          :label="input.title.replace(/___/g, '/').replace(/__/g, '-').replace(/_/g, ' ')"
                                          :value="input.value"
                                          v-model="input.value"
                                        ></v-text-field>

                                        <v-select
                                          outlined
                                          v-else-if="input.type === 'select'"
                                          :items="input.options"
                                          :label="input.title.replace(/___/g, '/').replace(/__/g, '-').replace(/_/g, ' ')"
                                          :value="input.value"
                                          v-model="input.value"
                                        ></v-select>

                                        <v-textarea
                                          v-else-if="input.type === 'textarea'"
                                          outlined
                                          :label="input.title"
                                          :value="input.value"
                                          v-model="input.value"
                                        ></v-textarea>

                                        <template 
                                          v-else-if="input.type === 'resp'"
                                          flat
                                        >
                                          <Responsabilities 
                                            :resps="input.value"
                                            @update-resps="updateResps"
                                          />
                                        </template>

                                        <v-menu
                                          v-else-if="input.type === 'datePicker'"
                                          v-model="input.menu_data_nasc"
                                          :close-on-content-click="false"
                                          :nudge-right="40"
                                          transition="scale-transition"
                                          offset-y
                                          min-width="290px"
                                        >
                                          <template v-slot:activator="{ on }">
                                            <v-text-field 
                                              outlined
                                              v-model="input.value"
                                              :label="input.title.replace(/___/g, '/').replace(/__/g, '-').replace(/_/g, ' ')"
                                              readonly
                                              v-on="on"
                                            ></v-text-field>
                                          </template>
                                          <v-date-picker
                                            v-model="input.value" 
                                            @input="input.menu_data_nasc = false"
                                          ></v-date-picker>
                                        </v-menu>

                                    </v-card-text>
                                  </v-card>
                                </v-col>
                              </v-row>
                              </v-tab-item>
                            </v-tabs-items>

                        </v-card>
                      </template>
                   </v-card>
                  </v-col>
                  <v-col
                    :cols="3"
                  >
                    <v-card class="colunas">
                      <h2>Próximo Contacto<span class="h2-underline"></span></h2>
                        <v-card flat class="callbacks-container" v-if="this.lead.callback_date == null">
                          Nenhum contacto agendado
                        </v-card>
                        <v-card flat class="callbacks-container" v-else>
                          {{this.lead.callback_date}}
                        </v-card>
                    </v-card>

                    <v-card class="colunas">
                      <h2>Histórico<span class="h2-underline"></span></h2>
                          <v-timeline
                            align-top
                            dense
                            class="timeline-container"
                          >

                            <v-timeline-item
                              v-for="(hist, i) in historico"
                              :key="i"
                              fill-dot
                              right
                              small
                              color="#999"
                            >
                              <v-card class="elevation-2">
                                <v-card-title class="timeline-date">{{hist.data}}</v-card-title>
                                <v-card-text>
                                  <b>Resultado:</b> {{hist.resultado}}
                                  <br>
                                  <b>Estado:</b> {{hist.estado}}
                                </v-card-text>
                              </v-card>
                            </v-timeline-item>

                          </v-timeline>
                    </v-card>

                  </v-col>
                </v-row>
              </v-container>
          </div>
        </div>
      </v-card>
        <v-snackbar
        v-model="snackbar"
        :color="snackbarColor"
        :timeout="3000"
        bottom
      >
        {{ snackbarMessage }}
        <v-btn
          dark
          text
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </v-snackbar>
    </v-dialog>
  </v-row>
</template>

<script>
  import Responsabilities from '@/components/Responsabilities';
  import Calls from '@/components/Calls';

  export default {
      components: {
        Responsabilities,
        Calls
      },
      name:'LeadInsertData',
      props: ["lead"],
    data () {
      return {
        snackbar: false,
        snackbarMessage: "",
        snackbarColor: "",
        dialog: false,
        notifications: false,
        sound: true,
        widgets: false,
        tab: null,
        items: [
          { tab: 'Resumo', desc: "obs", content: []},
          { tab: '1º Titular', desc: "prit", content: []},
          { tab: '2º Titular', desc: "sect", content: []},
          { tab: 'Operação', desc: "operation_data", content: []},
          { tab: 'Responsabilidades', desc: "responsabilities", content: []},
          { tab: 'Parecer', desc: "comercial_assessment", content: []},
        ],
        radioElem: [],

        historico: [],

        obs: [],
        pri_data: [],
        sec_data: [],
        operation: [],
        responsabilities: [],
        assessement: []
      }
    },
    methods: {
      reloadData: async function() {
        this.$emit('update-made', true)
      },
      reloadDataFinal: async function() {
        this.$emit('update-made', true)
        this.dialog = false
      },
      confirmClose: async function() {
        if(confirm("Estás prestes a fechar a ficha do processo.\nAs alterações não guardadas poderão ser perdidas.\n\nTens a certeza que pretendes continuar?")) {
          this.dialog = false
        }
      },
      updateLeadData: async function() {

        let pri_final_data = {}
        let sec_final_data = {}
        let operation_final_data = {}
        let responsabilities_final_data = {}
        
        let assessement_final_data = this.assessement[0].value
        let observations_final_data = this.obs[0].value

        for(let i in this.pri_data) {
          pri_final_data[this.pri_data[i].title] = this.pri_data[i].value
        }

        for(let i in this.sec_data) {
          sec_final_data[this.sec_data[i].title] = this.sec_data[i].value
        }

        for(let i in this.operation) {
          operation_final_data[this.operation[i].title] = this.operation[i].value
        }

        for(let i in this.responsabilities) {
          responsabilities_final_data[this.responsabilities[i].title] = this.responsabilities[i].value
        }

        this.lead.prit_data = pri_final_data
        this.lead.sect_data = sec_final_data
        this.lead.operation_data = operation_final_data
        this.lead.responsabilities = responsabilities_final_data
        this.lead.comercial_assessment = assessement_final_data
        this.lead.observations = observations_final_data

        if(confirm("Tens a certeza que queres guardar as alterações?")) {
          const res = await this.updateLeadDetails()

          if(res.resultado == "OK") {
            this.snackbarMessage = "As alterações foram guardadas com sucesso!"
            this.snackbarColor = "success"
          }
          else {
            this.snackbarMessage = res.details
            this.snackbarColor = "error"
          }

          this.snackbar = true

          // this.dialog = false
        }
      },
      updateLeadDetails: async function() {
        let url = "https://app.reorganiza.pt/public/api/update-lead-details/"+this.lead.lead_process_id
          let body = {
            prit_data: this.lead.prit_data,
            sect_data: this.lead.sect_data,
            operation_data: this.lead.operation_data,
            responsabilities: this.lead.responsabilities,
            comercial_assessment: this.lead.comercial_assessment,
            observations: this.lead.observations,
            contact_id: "0",
            username: window.sessionStorage.getItem('username')
          }

          const res = await this.call_api_post(url, body)

          return res
      },
      updateResps: async function(e) {
        this.responsabilities[4].value = e
      },
      groupLeadDetails: async function () {
        let dados = this.lead

        for(let prop in dados) {
          if(prop == "prit_data") {
            for(let i in dados[prop]) {
              if(i == "titulo") {
                this.pri_data.push(
                  {
                    title: i, 
                    value: dados[prop][i], 
                    type: "select", 
                    options: [
                      'Sr','Sr(a)', 'Dr', 'Dr(a)', 'Eng', 'Eng(a)'
                    ],
                    cols: "2"
                  }
                )
              }
              else if(i == "tipo_de_habitacao") {
                this.pri_data.push(
                  {
                    title: i, 
                    value: dados[prop][i], 
                    type: "select", 
                    options: [
                      'Própria','Arrendada','Familiares','Hipoteca (CH)'
                    ],
                    cols: "3"
                  }
                )
              }
              else if(i == "estado_civil") {
                this.pri_data.push(
                  {
                    title: i, 
                    value: dados[prop][i], 
                    type: "select", 
                    options: [
                      'Casado','Solteiro','Divorciado','Unido de Facto','Viuvo','Separado'
                    ],
                    cols: "2"
                  }
                )
              }
              else if(i == "tipo_de_documento") {
                this.pri_data.push(
                  {
                    title: i, 
                    value: dados[prop][i], 
                    type: "select", 
                    options: [
                      'BI','CARTÃO CIDADÃO','PASSAPORTE','DOC. IDENTIF MILITAR','TITULO RESIDÊNCIA','OUTRO'
                    ],
                    cols: "4"
                  }
                )
              }
              else if(i == "vinculo") {
                this.pri_data.push(
                  {
                    title: i, 
                    value: dados[prop][i], 
                    type: "select", 
                    options: [
                      'Efetivo','A termo Certo','A Termo Incerto','ENI','Funcionário Público','Recibos Verdes','Reformado / Pensionista'
                    ],
                    cols: "4"
                  }
                )
              }
              else if(i == "morada") {
                this.pri_data.push(
                  {
                    title: i, 
                    value: dados[prop][i], 
                    type: "text", 
                    cols: "9"
                  }
                )
              }
              else if(i == "nome") {
                this.pri_data.push(
                  {
                    title: i, 
                    value: dados[prop][i], 
                    type: "text", 
                    cols: "8"
                  }
                )
              }
              else if(i == "data_nascimento") {
                this.pri_data.push(
                  {
                    title: i, 
                    value: dados[prop][i], 
                    type: "datePicker",
                    menu_data_nasc: false,
                    cols: "3"
                  }
                )
              }
              else if(i == "email"){
                this.pri_data.push(
                  {title: i, value: dados[prop][i], type: "text", cols: "5"}
                )
              }
              else {
                this.pri_data.push(
                  {title: i, value: dados[prop][i], type: "text", cols: "4"}
                )
              }
            }
          }
          else if(prop == "sect_data") {
            for(let i in dados[prop]) {
              if(i == "titulo") {
                this.sec_data.push(
                  {
                    title: i, 
                    value: dados[prop][i], 
                    type: "select", 
                    options: [
                      'Sr','Sr(a)', 'Dr', 'Dr(a)', 'Eng', 'Eng(a)'
                    ],
                    cols: "2"
                  }
                )
              }
              else if(i == "tipo_de_habitacao") {
                this.sec_data.push(
                  {
                    title: i, 
                    value: dados[prop][i], 
                    type: "select", 
                    options: [
                      'Própria','Arrendada','Familiares','Hipoteca (CH)'
                    ],
                    cols: "3"
                  }
                )
              }
              else if(i == "estado_civil") {
                this.sec_data.push(
                  {
                    title: i, 
                    value: dados[prop][i], 
                    type: "select", 
                    options: [
                      'Casado','Solteiro','Divorciado','Unido de Facto','Viuvo','Separado'
                    ],
                    cols: "2"
                  }
                )
              }
              else if(i == "tipo_de_documento") {
                this.sec_data.push(
                  {
                    title: i, 
                    value: dados[prop][i], 
                    type: "select", 
                    options: [
                      'BI','CARTÃO CIDADÃO','PASSAPORTE','DOC. IDENTIF MILITAR','TITULO RESIDÊNCIA','OUTRO'
                    ],
                    cols: "4"
                  }
                )
              }
              else if(i == "vinculo") {
                this.sec_data.push(
                  {
                    title: i, 
                    value: dados[prop][i], 
                    type: "select", 
                    options: [
                      'Efetivo','A termo Certo','A Termo Incerto','ENI','Funcionário Público','Recibos Verdes','Reformado / Pensionista'
                    ],
                    cols: "4"
                  }
                )
              }
              else if(i == "morada") {
                this.sec_data.push(
                  {
                    title: i, 
                    value: dados[prop][i], 
                    type: "text", 
                    cols: "9"
                  }
                )
              }
              else if(i == "nome") {
                this.sec_data.push(
                  {
                    title: i, 
                    value: dados[prop][i], 
                    type: "text", 
                    cols: "8"
                  }
                )
              }
              else if(i == "estado_civil") {
                this.sec_data.push(
                  {
                    title: i, 
                    value: dados[prop][i], 
                    type: "text", 
                    cols: "2"
                  }
                )
              }
              else if(i == "data_nascimento") {
                this.sec_data.push(
                  {
                    title: i, 
                    value: dados[prop][i], 
                    type: "datePicker",
                    menu_data_nasc: false,
                    cols: "3"
                  }
                )
              }
              else if(i == "email"){
                this.sec_data.push(
                  {title: i, value: dados[prop][i], type: "text", cols: "5"}
                )
              }
              else {
                this.sec_data.push(
                  {title: i, value: dados[prop][i], type: "text", cols: "4"}
                )
              }
            }
          }
          else if(prop == "observations") {
            this.obs.push(
              {title: prop, value: dados[prop], type: "textarea"}
            )
          }
          else if(prop == "comercial_assessment") {
            this.assessement.push(
              {title: prop, value: dados[prop], type: "textarea"}
            )
          }
          else if(prop == "operation_data") {
            for(let i in dados[prop]) {
              if(i == "adesao_ao_seguro") {
                this.operation.push(
                  {
                    title: i, 
                    value: dados[prop][i], 
                    type: "select", 
                    options: [
                      "Sim",
                      "Não"
                    ],
                    cols: "4"}
                )
              }
              else if(i == "operacao") {
                this.operation.push(
                  {
                    title: i, 
                    value: dados[prop][i], 
                    type: "select", 
                    options: [
                      "Consolidado",
                      "Pessoal",
                      "Habitação",
                      "Automóvel",
                      "Obras"
                    ],
                    cols: "4"}
                )
              }
              else {
                this.operation.push(
                  {title: i, value: dados[prop][i], type: "text", cols: "4"}
                )
              }
            }
          }
          else if(prop == "responsabilities") {
            for(let i in dados[prop]) {
              if(i == "resp") {
                this.responsabilities.push(
                  {
                    title: i, 
                    value: dados[prop][i], 
                    type: "resp",
                    cols: "12"}
                )
              }
              else {
                this.responsabilities.push(
                  {title: i, value: dados[prop][i], type: "text", cols: "6"}
                )
              }
            }
          }
        }
      },
      collect_lead_history: async function () {
        let url = "https://app.reorganiza.pt/public/api/lead-process-logs/results/"+this.lead.lead_process_id

        const dados = await this.call_api_get(url)

        this.historico = dados
        
        await this.collect_possible_results()
      },
      collect_possible_results: async function () {
        let url = "https://app.reorganiza.pt/public/api/possible-results/"+this.lead.current_step_id

        const dados = await this.call_api_get(url)

        let temp = []

        for(let i in dados) {
          temp.push({
            label: dados[i].name,
            value: dados[i].id
          })
        }

        this.radioElem = temp
      },
      call_api_get: async function (url) {
          try {
              var response = await fetch(url, {
                  method: 'GET',
                  headers: {
                      'Content-Type': 'application/json'
                  }
              })
              var result = await response.json()
              return result
          }
          catch (error) {
              console.error('Error:', error)
              return 'Error: ' + error
          }
      },
      call_api_post: async function(url, apiBody) {
        try {
            var response = await fetch(url, {
                method: 'POST',
                headers: {
                    'content-type': 'application/json'
                },
                body: JSON.stringify(apiBody, null, 2)
            })
            var result = await response.json()
            return result
        }
        catch (error) {
            console.error('Error:', error)
            return 'Error: ' + error
        }
      },
      pouplateFormContent: async function() {
        for(let item of this.items) {
          if(item.desc == "prit") {
            for(let j of this.pri_data) {
              item.content.push(
                j
              )
            }
          }
          else if(item.desc == "sect") {
            for(let j of this.sec_data) {
              item.content.push(
                j
              )
            }
          }
          else if(item.desc == "obs") {
            for(let j of this.obs) {
              item.content.push(
                j
              )
            }
          }
          else if(item.desc == "operation_data") {
            for(let j of this.operation) {
              item.content.push(
                j
              )
            }
          }
          else if(item.desc == "comercial_assessment") {
            for(let j of this.assessement) {
              item.content.push(
                j
              )
            }
          }
          else if(item.desc == "responsabilities") {
            for(let j of this.responsabilities) {
              item.content.push(
                j
              )
            }
          }
        }
      },
      formatDate: async function(date) {
          if(date == null || date == 'null') {
              return false
          }
          else {
              let hours = date.getHours() < 10 ? "0"+date.getHours() : date.getHours()
              let minutes = date.getMinutes()
              let dia = date.getDate() < 10 ? "0"+date.getDate() : date.getDate()
              let mes = (date.getMonth()+1) < 10 ? "0"+(date.getMonth()+1) : (date.getMonth()+1)

              let strTime = hours + ':' + minutes + ':00'

              return date.getFullYear() + "-" + mes + "-" + dia + " " + strTime
          }
      },
    },
    mounted: async function() {
      this.groupLeadDetails()
      this.pouplateFormContent()
      this.collect_lead_history()
    },
    watch: {
      lead: async function (newLead) {
        this.lead = newLead
        
        this.items = [
          { tab: 'Resumo', desc: "obs", content: []},
          { tab: '1º Titular', desc: "prit", content: []},
          { tab: '2º Titular', desc: "sect", content: []},
          { tab: 'Operação', desc: "operation_data", content: []},
          { tab: 'Responsabilidades', desc: "responsabilities", content: []},
          { tab: 'Parecer', desc: "comercial_assessment", content: []},
        ]
        this.pri_data = []
        this.sec_data = []
        this.obs = []
        this.operation = []
        this.assessement = []
        this.responsabilities = []
        this.radioElem = []

        this.groupLeadDetails()
        this.pouplateFormContent()
        this.collect_lead_history()
      }
    }
  }
</script>

<style scoped>
    h1{
      margin-left: 40px;
      color: black;
      font-size: 20px;
      text-transform: uppercase;
      margin-top: 50px;
      position: relative;
      display: block;
    }
    .h1-underline{
      position: absolute;
      left: 0;
      bottom: 0;
      width: 60px;
      height: 3px;
      background-color: black;
      margin-bottom: -6px;
    }

    h2{
      margin-left: 40px;
      color: black;
      font-size: 14px;
      text-transform: uppercase;
      position: relative;
      display: block;
    }
    .h2-underline{
      position: absolute;
      left: 0;
      bottom: 0;
      width: 80%;
      height: 1px;
      background-color: black;
      margin-bottom: -6px;
    }

    .container{
      margin: 10px 0px;
      max-width: 100%;
    }

    .colunas{
      padding: 20px 0;
      margin-top: 10px;
    }

    .colunas-interiores{
      padding: 20px 40px;
    }

    .v-list-item{
      min-height: 10px;
      padding:0;
      margin-bottom: 0!important;
    }

    .v-list-item__content{
      padding:8px 0;
    }

    .v-list-item__title{
      font-size:14px;
    }

    h3{
      font-size:14px;
      margin-bottom:10px;
    }
    .v-item-group{
      padding: 0 30px;
    }
    .v-list-item__icon{
      margin-right: 10px!important;
      margin-left: 20px;
    }

    .tabs-container{
      padding: 0px 40px;
      margin-top:20px;
    }

    .callbacks-container{
      padding: 0px 40px;
      margin-top:20px;
      padding-right: 20px;
    }

    .v-tabs-items{
      padding:0;
      margin-top: 20px;
    }

    .inputs-container{
      margin:0;
      padding:0;
    }

    .timeline-date {
      font-size: 14px;
      padding-bottom: 5px!important;
    }

    .timeline-container {
      margin-top: 20px;
      padding-right: 10px;
    }

    .col-padding {
      padding: 0px 10px !important;
    }

    .h3-resumo {
      font-weight: normal;
    }

    .h2-resumo {
      margin-left: 0;
    }

    .call-button {
      position: absolute;
      top: 15px;
      right: 25px;
      z-index: 1;
    }

</style>
   